import { RedoOutlined } from '@ant-design/icons';
// <RotateLeftOutlined />
import logo from '@assets/images/static/img_logo_byes.png';
import Div100vh from 'react-div-100vh';
import { styled } from 'styled-components';

function ScreenOrientation() {
  return (
    <Container>
      <SLogo src={logo} alt="" />
      <br />
      <RedoOutlined style={{ color: '#fff', fontSize: '32px' }} />
      <br />
      <Sp>
        {window.navigator.maxTouchPoints > 0
          ? ' Tournez votre téléphone pour profiter pleinement de cette expérience'
          : ' Agrandissez la taille de votre navigateur pour profiter pleinement de cette expérience'}
      </Sp>
    </Container>
  );
}

export default ScreenOrientation;

const Container = styled(Div100vh)`
  align-items: center;
  background: #33b2cf;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  .icon {
    font-size: 5rem;
    color: #fff;
    @media screen and (max-height: 667px) {
      font-size: 3rem;
    }
  }
  .icon-small {
    font-size: 3rem;
    color: #fff;
    margin-top: 24px;
    @media screen and (max-height: 667px) {
      font-size: 2rem;
    }
  }
`;

const SLogo = styled.img`
  height: 20%;
  width: auto;
`;

const Sp = styled.p`
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  width: 80%;
  line-height: 2.5rem;
  height: auto;
  @media screen and (max-height: 715px) {
    font-size: 2rem;
  }
  @media screen and (max-height: 667px) {
    font-size: 1.8rem;
  }
`;
